var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"location_map"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.googleMapsSrc,"width":"600","height":"450","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }